import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import React, { Fragment } from "react";
import { AdminManagePresidentialChartState } from "../../hooks/use-manage-presidential-chart";

const AdminManagePresidentialChartProposals: React.FC<{
  state: AdminManagePresidentialChartState;
}> = ({
  state: {
    proposalsFieldArray,
    form: { control, register, formState },
  },
}) => {
  return (
    <div className="my-8">
      <div className="font-medium tracking-widest uppercase">
        Number of proposals
      </div>
      <Listbox
        value={
          (proposalsFieldArray.fields && proposalsFieldArray.fields.length) || 0
        }
        onChange={(e) => {
          let num = e - proposalsFieldArray.fields.length;
          if (num < 0) {
            while (num !== 0) {
              proposalsFieldArray.remove(-1);
              num++;
            }
          } else if (num > 0) {
            while (num !== 0) {
              proposalsFieldArray.append({ name: "" });
              num--;
            }
          }
        }}
      >
        <div className="relative h-[48px] mt-2">
          <Listbox.Button className="relative w-64 h-full px-4 py-3 text-left bg-white border rounded-md border-primary-blue">
            <span className="block truncate">
              {(proposalsFieldArray.fields &&
                proposalsFieldArray.fields.length) ||
                0}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <ChevronUpDownIcon
                className="w-5 h-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 w-64 py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {Array.from({ length: 21 }, (_, i) => i).map((count, i) => (
                <Listbox.Option
                  key={`write-in-${i}`}
                  className={({ active }) =>
                    `cursor-default select-none relative py-2 pl-10 pr-4 ${
                      active ? "text-blue-900 bg-blue-100" : "text-gray-900"
                    }`
                  }
                  value={count}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {count}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600">
                          <CheckIcon className="w-5 h-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
      {proposalsFieldArray.fields.map((proposal, i) => (
        <input
          key={proposal.id}
          {...register(`proposals.${i}.name`)}
          type="text"
          placeholder="Proposal Name"
          className={classNames(
            "w-full mt-2 px-4 py-3 border rounded-md border-primary-blue",
            {
              "border-red-500 focus:outline-red-500":
                formState?.errors?.proposals?.[i]?.name,
            }
          )}
        />
      ))}
    </div>
  );
};

export default AdminManagePresidentialChartProposals;
